window.marmeto = window.marmeto || {};

marmeto.RecentlyViewedProducts = (function() {
  function RecentlyViewedProducts(element) {
    this.container = document.querySelector('[data-section-type="' + element + '"]');
    
    if(!this.container) {
      return;
    }

    const rawSettings = this.container.getAttribute('data-section-settings').replace(/'/g, '"');
    this.options = JSON.parse(rawSettings);

    if (this.options['productId']) {
      this.saveCurrentProduct();
    }

    this.fetchWhenNearViewport();
    this.attachEventListeners();
  }

  RecentlyViewedProducts.prototype.fetchWhenNearViewport = function() {
    // Nothing to show: hide the section now, as before. Otherwise fetch the products when the section
    // comes near the viewport (like the product recommendations), not during page load.
    if (this.getSearchQueryString() === '' || !('IntersectionObserver' in window)) {
      this.fetchProducts();
      return;
    }

    const _this = this;
    new IntersectionObserver(function(entries, observer) {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      _this.fetchProducts();
    }, { rootMargin: '0px 0px 400px 0px' }).observe(this.container);
  }
  
  RecentlyViewedProducts.prototype.attachEventListeners = function() {
    //ADD ANY EVENTLISTENERS LIKE :: ADD TO CART, QUICK VIEW ETC..
  }
  
  RecentlyViewedProducts.prototype.fetchProducts = function() {
    const _this = this;   
    const queryString = this.getSearchQueryString();

    if (queryString === '') {
      _this.container.classList.add('hidden');
      return;
    }

    fetch(("/search?view=mm-recently-viewed&type=product&q=").concat(queryString), {
      credentials: 'same-origin',
      method: 'GET'
    })
    .then(function (response) {
      return response.text();
    })
    .then(function (content) {
      // DOMParser: unlike innerHTML on a detached div, it does not start the carousel in the copy.
      const fetchedDocument = new DOMParser().parseFromString(content, 'text/html');

      const sourceContainer = fetchedDocument.querySelector('[data-section-type="mm-recently-viewed-products"] .mm-recentlyviewed__container');
      const targetContainer = _this.container.querySelector('.mm-recentlyviewed__container');

      if (sourceContainer && targetContainer) {
        _this.container.querySelector(".related-products__heading")?.classList.remove("hidden");
        _this.container.parentNode.style.display = 'block';
        // The carousel starts itself when inserted; start it here only if that did not happen.
        targetContainer.innerHTML = sourceContainer.innerHTML;
        const carousel = targetContainer.querySelector('carousel-component');
        if (carousel && !carousel.carousel && typeof carousel.initCarousel === 'function') carousel.initCarousel();
      } else {
        console.error('Source or target container not found');
      }
    })
    .catch(function (error) {
      console.error('Error fetching recently viewed products:', error);
    });
  }
  
  RecentlyViewedProducts.prototype.saveCurrentProduct = function() {
    /*
     * - Check if the current product already exists, and if it does not, add it at the start
     * - Then, we save the current product into the local storage, by keeping only the 18 most recent
    */
    let items = JSON.parse(localStorage.getItem('mmRecentlyViewedProducts')) || [];
    const productId = this.options['productId']; 

    if (!Array.isArray(items)) {
      items = [];
    }

    if (!items.includes(productId)) {
      items.unshift(productId);
    }

    try {
      localStorage.setItem('mmRecentlyViewedProducts', JSON.stringify(items.slice(0, 8)));
    } 
    catch (error) {
      console.error('Error saving recently viewed products:', error);
    }
  }
  
  RecentlyViewedProducts.prototype.getSearchQueryString = function() {
    let items = JSON.parse(localStorage.getItem('mmRecentlyViewedProducts')) || [];
    
    if (!Array.isArray(items)) {
      items = [];
    }

    if (items.includes(this.options['productId'])) {
      items.splice(items.indexOf(this.options['productId']), 1);
    }

    return items.map(function (item) {
      return 'id:' + item;
    }).join(' OR ');
  }
  
  RecentlyViewedProducts.prototype.initSlider = function() {
    //INITIALIZE THE SLIDER HERE
    //PARENT ELEMENT IS :: .mm-recentlyviewed__products
  }
  
  return RecentlyViewedProducts;
})();

new marmeto.RecentlyViewedProducts('mm-recently-viewed-products');
